import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Point, Size, Rect } from '../utils/geometry';
import drawMultilineText from 'canvas-multiline-text';

const isMobile = () => {
	return window.Modernizr.mobile;
};

class RectSize {
	constructor(width, height) {
		this.width = width;
		this.height = height;
	}
}

class ImageDescriptor {
	constructor(image, rotation = 0, include = true, resize = false, useOffset = false) {
		this.image = image;
		this.rotation = rotation;
		this.include = include;
		this.resize = resize;
		this.useOffset = useOffset;
		Object.freeze(this);
	}

	get width() {
		return this.image.width;
	}

	get height() {
		return this.image.height;
	}

	static create(image, rotation, include, resize, useOffset) {
		return new ImageDescriptor(...arguments);
	}
}

const imageSizeThatFitsInSize = (image, size, isAspectFit) => {
	const widthScale = size.width / image.width;
	const heightScale = size.height / image.height;
	const scale = isAspectFit ? Math.min(widthScale, heightScale) : Math.max(widthScale, heightScale);
	return new Size(Math.round(image.width * scale), Math.round(image.height * scale));
};

const drawImagesInCanvas = (canvas, imageDescriptors, offset, includeAll = true) => {
	console.group('MemeCanvas.drawImagesInCanvas()');
	console.info('\t-> offset:', offset);

	const ctx = canvas.getContext('2d');
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	for (const imageDesc of imageDescriptors) {
		if (!includeAll && !imageDesc.include) {
			continue;
		}
		const { image, rotation, useOffset } = imageDesc;
		const offsetValue = useOffset ? offset : 0;
		const size = imageDesc.resize
			? imageSizeThatFitsInSize(image, new Size(canvas.width, canvas.height))
			: new Size(image.width, image.height);
		// save the unrotated context of the canvas so we can restore it later
		// the alternative is to untranslate & unrotate after drawing
		ctx.save();
		if (rotation > 0) {
			// move to the center of the canvas
			ctx.translate(canvas.width / 2 + offsetValue, canvas.height / 2);

			// rotate the canvas to the specified degrees
			ctx.rotate((rotation * Math.PI) / 180);

			ctx.drawImage(image, size.width / -2, size.height / -2, size.width, size.height);
		} else {
			ctx.translate(offsetValue, 0);
			ctx.drawImage(image, 0, 0, size.width, size.height);
		}

		// we’re done with the rotating so restore the unrotated context
		ctx.restore();
	}
	console.groupEnd();
};

/*
{
	"location": {
		"x": 19,
		"y": 408,
		"width": 200
	},
	"style": {
		"fontFamily": "Helvetica LT W01 Light",
		"fontSize": 38,
		"fontUnit": "px",
		"color": "#ffffff",
		"fontStyle": "normal"
	}
}
*/

const fitTextInWidth = (ctx, field) => {
	const { style, location } = field;
	ctx.font = `${style.fontStyle} ${style.fontSize}${style.fontUnit} ${style.fontFamily}`;
	var { fontSize } = style,
		metrics = ctx.measureText(field.text);
	while (metrics.width > location.width) {
		ctx.font = `${style.fontStyle} ${--fontSize}${style.fontUnit} ${style.fontFamily}`;
		metrics = ctx.measureText(field.text);
	}
	return { metrics: metrics, fontSize: fontSize, yOffset: (style.fontSize - fontSize) / 2 || 0 };
};

const drawTextInCanvas = (canvas, fields) => {
	const ctx = canvas.getContext('2d');

	fields.forEach(field => {
		const metrics = fitTextInWidth(ctx, field);
		const { style, location } = field;

		ctx.fillStyle = style.color;
		//ctx.font = `${style.fontStyle} ${metrics.fontSize}${style.fontUnit} ${style.fontFamily}`;
		const element = document.getElementById(field.id) || {
			offsetLeft: 0,
			offsetTop: 0,
			offsetWidth: 0,
			offsetHeight: 0,
		};

		const fieldElement = document.getElementById(field.id) || {
			getBoundingClientRect: () => ({ bottom: 0, height: 0, left: 0, right: 0, top: 0, width: 0, x: 0, y: 0 }),
			focus: () => {},
		};

		const fieldBounds = fieldElement.getBoundingClientRect();
		const canvasBounds = canvas.getBoundingClientRect();

		const factor = canvasBounds.width / canvas.width;

		//const textX = location.x;
		const textX = (parseFloat(field.location.x) / 100) * canvas.width;
		const textY = (parseFloat(field.location.y) / 100) * canvas.height;

		const textWidth = fieldBounds.width;
		const textHeight = fieldBounds.height;

		// console.group('drawTextInCanvas()');
		// console.info('\t-> fieldBounds:', fieldBounds);
		// console.info('\t-> canvasBounds:', canvasBounds);
		// console.info('\t-> field:', field);
		// console.info('\t-> element:', document.getElementById(field.id));
		// console.info('\t-> textX:', textX);
		// console.info('\t-> textY:', textY);
		// console.info('\t-> textWidth:', textWidth);
		// console.info('\t-> textHeight:', textHeight);
		// console.info('\t-> factor:', factor);
		// console.info('\t-> isMobile:', isMobile());
		// console.info('\t-> style.fontSize:', style.fontSize);
		// console.info('\t-> fontSize:', isMobile() ? style.fontSize * 2 : style.fontSize * factor);
		// console.groupEnd();

		console.info('field:', field);

		drawMultilineText(ctx, field.text, {
			rect: {
				x: textX,
				y: textY,
				width: isMobile() ? textWidth * 1.8 : textWidth,
				height: textHeight,
			},
			font: style.fontFamily,
			verbose: true,
			lineHeight: style.lineHeight,
			minFontSize: isMobile() ? style.minFontSize * 2 : style.minFontSize * factor,
			maxFontSize: isMobile() ? style.fontSize * 2 : style.fontSize * factor,
		});

		fieldElement.focus();

		//ctx.fillText(field.text, textX, textY);
	});
};

class MemeCanvas extends Component {
	get imageDescriptors() {
		const { imageDescriptors } = this.props;
		return imageDescriptors.filter(imgDesc => {
			return imgDesc != undefined;
		});
	}

	get fields() {
		const { fields } = this.props;
		return fields;
	}

	componentDidMount() {
		this.drawCanvas();
	}

	drawCanvas() {
		console.group('MemeCanvas.drawCanvas()');
		console.info('\t-> this.props:', this.props);
		console.groupEnd();

		const { canvas } = this.refs;

		drawImagesInCanvas(canvas, this.imageDescriptors, this.props.offset);
		drawTextInCanvas(canvas, this.fields);
	}

	componentDidUpdate() {
		this.drawCanvas();
	}

	getCanvasImage() {
		if (this.refs.canvas) {
			this.drawCanvas(false);
			const img = this.refs.canvas.toDataURL('image/png');
			this.drawCanvas(true);
			return img;
		} else {
			return undefined;
		}
	}

	render() {
		const { width, height } = this.props;
		return (
			<div id="meme-canvas" class="col-xs-12 padding-none relative overflow-hidden">
				{this.props.children}
				<canvas ref="canvas" width={width} height={height}>
					<h2>HTML canvas is not supported by your browser!</h2>
					<p>To run this app, please open this url on a modern browser.</p>
				</canvas>
			</div>
		);
	}
}

MemeCanvas.propTypes = {
	imageDescriptors: PropTypes.array.isRequired,
	width: PropTypes.number.isRequired,
	height: PropTypes.number.isRequired,
	textDescriptor: PropTypes.object.isRequired,
};

export default MemeCanvas;
export { ImageDescriptor };



// WEBPACK FOOTER //
// ./src/js/components/memeCanvas.js